import { render, staticRenderFns } from "./FormulaireSmaStorage.vue?vue&type=template&id=2cca8b5d&"
import script from "./FormulaireSmaStorage.vue?vue&type=script&lang=js&"
export * from "./FormulaireSmaStorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports